<template>
    <div class="d-flex flex-column flex-root app-root" data-kt-app-layout="dark-sidebar" data-kt-app-sidebar-enabled="true" data-kt-app-sidebar-fixed="true" data-kt-app-sidebar-hoverable="true" data-kt-app-sidebar-push-header="true" data-kt-app-header-fixed="true">
        <div class="app-page flex-column flex-column-fluid">
            <DHeader/>
            <div id="kt_app_wrapper" class="app-wrapper flex-column flex-row-fluid">
                <DSidebar/>
                <div id="kt_app_main" class="app-main flex-column flex-row-fluid">

                    <div class="d-flex flex-column flex-column-fluid">
                        <div id="kt_app_content" class="app-content flex-column-fluid">
                            <div id="kt_app_content_container" class="app-container container-fluid">
                                <router-view v-slot="{ Component }">
                                    <component :is="Component" />
                                </router-view>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <ScrollTopArrow/>
        </div>
    </div>

</template>
<script>
import DHeader from '../views/components/admin/DHeader'
import DSidebar from '../views/components/admin/DSidebar'
import ScrollTopArrow from '../views/components/partials/ScrollTopArrow'
import { reloadRolesAndPermissions } from 'laravel-permission-to-vuejs'

export default {
    name: 'Default',
    components: {
        ScrollTopArrow,
        DHeader,
        DSidebar
    },
    created() {
        console.log( 'reloadRolesAndPermissions' , window.Laravel.jsPermissions);

    },
    methods: {
    },
    data () {
        return {

        }
    }
}
</script>
<style>

</style>
